module.exports = __webpack_public_path__ + ".htaccess";


/*****************
 ** WEBPACK FOOTER
 ** ./src/.htaccess
 ** module id = 672
 ** module chunks = 0
 **/